import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BarGraph from "../../../general/BarGraph";
import styles from "./ObraL3.module.css";
import { ObraStore } from "./ObraStore";

function ObraL3({ distrito }) {
  const [assistenciaTecnica, setAssistenciaTecnica] = useState(null);

  const gerenciaPropriedadeValue = ObraStore(
    (state) => state.gerenciaPropriedadeValue
  );

  const maoDeObraValue = ObraStore((state) => state.maoDeObraValue);

  const organizacaoValue = ObraStore((state) => state.organizacaoValue);

  const setAssistenciaTecnicaImage = ObraStore((state) => state.setAssistenciaTecnicaImage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [assistenciaTecnica] = await Promise.all([
          Api.getAssistenciaTecnica(
            distrito,
            gerenciaPropriedadeValue,
            maoDeObraValue,
            organizacaoValue
          ),
        ]);
        setAssistenciaTecnica(Functions.buildBarGraph(assistenciaTecnica));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [distrito, gerenciaPropriedadeValue, maoDeObraValue, organizacaoValue]);

  return (
    <div className={styles.obraL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {assistenciaTecnica && (
            <BarGraph
              data={assistenciaTecnica}
              text="USO DE ASSISTÊNCIA TÉCNICA"
              onImageReady={setAssistenciaTecnicaImage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ObraL3;
